import { Timestamp } from 'firebase/firestore';

export const membershipToFirestore = (values, tenantData, authUser) => {
    const idTenant = typeof tenantData === 'string' ? tenantData : tenantData?.id;
    if (!idTenant) throw new Error("ID do Tenant é obrigatório.");
    const data = {
        name: values.name?.trim(),
        type: values.type,
        durationType: values.durationType,
        duration: Number(values.duration),
        value: Number(values.value),
        maxInstallments: Number(values.maxInstallments),
        description: values.description?.trim(),
        status: values.status,
        allowsCancellationByApp: !!values.allowsCancellationByApp,
        cancellationFee: Number(values.cancellationFee),
        cancellationNoticeDays: Number(values.cancellationNoticeDays),
        allowsSuspension: !!values.allowsSuspension,
        maxSuspensionDays: Number(values.maxSuspensionDays),
        suspensionFee: Number(values.suspensionFee),
        enrollmentRequired: !!values.enrollmentRequired,
        memberXp: Number(values.memberXp),
        employeeXp: Number(values.employeeXp),

        idTenant,
        updatedAt: Timestamp.now(),
        updatedBy: {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        }
    };

    if (values.order !== undefined) {
        data.order = values.order;
    }

    if (!values.id) {
        data.createdAt = Timestamp.now();
        data.createdBy = {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        };
    }

    return Object.fromEntries(Object.entries(data).filter(([_, v]) => v !== undefined));
};
